var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSinglepocket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st163{fill:#FFFFFF;stroke:#010101;stroke-width:3;stroke-miterlimit:10;}\n\t.st162{fill:#FFFFFF;stroke:#010101;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st163",
    d: "M153.49,100.59c-2.38,12.23-5.43,30.15-7.55,51.94c-4.99,51.34-1.32,88.67,1.72,124.52 c1.53,18.13-0.24,41.35,1.54,67.74s3.18,55.64,4.82,90c5.66-0.1,15.78,0.76,21.53,0.33c5.58-0.42,18.02-0.57,23.47-1.33 c-2.94-28.43-8.51-62.66-6.57-98.68c2.78-51.48,8.73-95.81,18.71-131.94c0.11-32.8,0.23-69.59,0.34-102.39 C192.16,99.39,172.83,101.99,153.49,100.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st163",
    d: "M269.51,100.59c2.38,12.23,5.43,30.15,7.55,51.94c4.99,51.34,1.32,88.67-1.72,124.52 c-1.53,18.13,0.24,41.35-1.54,67.74s-0.15,55.64-1.78,90c-5.66-0.1-18.81,0.76-24.56,0.33c-5.58-0.42-15.99-2.57-21.44-3.33 c2.94-28.43,6.48-60.66,4.53-96.68c-2.78-51.48-8.73-95.81-18.71-131.94c-0.11-32.8-0.23-69.59-0.34-102.39 C230.84,99.39,250.17,101.99,269.51,100.59z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st162",
    points: "270.02,100.13 153.02,100.13 155.02,86.13 268.02,86.13  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.79,
    y: 84.8,
    transform: "matrix(0.9998 0.0211 -0.0211 0.9998 2.0276 -4.2607)",
    className: "st162",
    width: 4.78,
    height: 18.55
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.79,
    y: 84.8,
    transform: "matrix(0.9998 0.0211 -0.0211 0.9998 2.0183 -3.3757)",
    className: "st162",
    width: 4.78,
    height: 18.55
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.79,
    y: 84.8,
    transform: "matrix(-0.9998 0.0211 -0.0211 -0.9998 442.296 183.4955)",
    className: "st162",
    width: 4.78,
    height: 18.55
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.79,
    y: 84.8,
    transform: "matrix(-0.9998 0.0211 -0.0211 -0.9998 528.2864 182.5894)",
    className: "st162",
    width: 4.78,
    height: 18.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M181.02,102.13c-1,11-2,18-3,29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M244.02,102.13c1,11,2,17,3,28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.02,
    y: 130.13,
    className: "st162",
    width: 38,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.02,
    y: 132.13,
    className: "st162",
    width: 38,
    height: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinglepocket);
export default __webpack_public_path__ + "static/media/SINGLE POCKET.873d4a2fc197c208564d16d9558a0ca3.svg";
export { ForwardRef as ReactComponent };